import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_Thunderstorm, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_EditorHeader } from '@app/styles';
import { __stringify, cloneObj, dbObjectToId } from '@nu-art/ts-common';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { ICONS } from '@app/styles';
import { cleanFindingViewSection, findingViewType_Parent, findingViewType_Sections, sectionRenderMethod_Inline } from '@app/advisor-ui-shared';
import './Editor_FidingView.scss';
import { SearchableItem_FindingView } from '../Page_AdvisorUI/consts.js';
import { DropDown_FindingViewType, MultiSelect_FindingView } from '../../_entity/finding-view/ui-components.js';
import { ModuleFE_AdvisorWizard } from '@app/advisor-content-frontend/index';
import { DropDown_AdvisorWizard } from '@app/advisor-content-frontend/_entity/wizard/ui-components';
import { sectionSortMethod_Alphabet } from '@app/advisor-ui-shared/_enum/section-sort-method/index';
import { DropDown_SectionSortMethod } from '../../_enum/section-sort-method/ui-components.js';
import { DropDown_SectionRenderMethod } from '../../_enum/finding-view-section/ui-components.js';
import { Editor_FindingViewSections } from '../../_enum/finding-view-section/Editor_FindingViewSections/Editor_FindingViewSections.js';
import { ModuleFE_FindingView } from '../../_entity/finding-view/ModuleFE_FindingView.js';
const viewMode_View = 'view';
const viewMode_Edit = 'edit';
export class Editor_FindingView extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode ?? (!state.editable.item._id ? true : (this.state?.editMode ?? false));
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    getItemActions = () => {
        return [{
                label: 'Edit Finding View',
                action: async () => this.setState({ editMode: true }),
            }, {
                label: 'Delete Finding View',
                action: async () => {
                    await this.state.editable.delete();
                    this.props.deselect?.();
                }
            }, {
                label: 'Export JSON',
                action: async () => {
                    const item = this.state.editable.item;
                    ModuleFE_Thunderstorm.downloadFile({
                        fileName: `Finding View - ${item.label}`,
                        mimeType: 'application/json',
                        content: __stringify(item, true)
                    });
                }
            }];
    };
    getEditModeActions = () => {
        const actions = [];
        //Actions for existing item
        if (this.state.editable.item._id)
            actions.push({
                label: 'Done',
                action: async () => this.setState({ editMode: false }),
            });
        //Actions for new item
        else {
            if (this.props.deselect)
                actions.push({
                    label: 'Cancel',
                    action: async () => {
                        return this.props.deselect();
                    },
                });
            actions.push({
                label: 'Save',
                action: async () => {
                    await this.state.editable.save();
                },
            });
        }
        return actions;
    };
    onFindingViewTypeSelected = async (type) => {
        const editable = this.state.editable;
        if (type === editable.item.type)
            return;
        const findingView = cloneObj(editable.item);
        findingView.type = type;
        switch (type) {
            case findingViewType_Parent: {
                const keysToDelete = ['sections', 'sectionRenderMethod', 'sectionSortMethod'];
                keysToDelete.forEach(key => findingView[key] = undefined);
                findingView.childrenIds = [];
                break;
            }
            case findingViewType_Sections: {
                const keysToDelete = ['childrenIds'];
                keysToDelete.forEach(key => findingView[key] = undefined);
                findingView.sections = [];
                findingView.sectionRenderMethod = sectionRenderMethod_Inline;
                findingView.sectionSortMethod = sectionSortMethod_Alphabet;
            }
        }
        editable.updateItem(findingView);
        return editable.save();
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'editor__finding-view', children: [!this.props.hideHeader && this.renderHeader(), this.renderBody()] });
    }
    renderHeader = () => {
        return _jsx(Component_EditorHeader, { editable: this.state.editable, searchItem: SearchableItem_FindingView, editMode: this.state.editMode, itemActions: this.getItemActions(), editModeActions: this.getEditModeActions() });
    };
    renderBody = () => {
        return _jsxs(LL_H_C, { className: 'editor__finding-view__body', children: [_jsxs(LL_V_L, { className: 'editor__finding-view__left', children: [this.renderEditor_Label(), this.renderEditor_Type(), this.renderEditor_ConnectedWizard(), this.renderEditors_ParentFindingView(), this.renderEditors_SectionsMeta()] }), this.renderEditors_SectionsContent()] });
    };
    renderEditor_Label = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: editable.item.label }) },
                    { key: viewMode_Edit, renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'label' }) }
                ] }) });
    };
    renderEditor_Type = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Type', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: editable.item.type }) },
                    { key: viewMode_Edit, renderer: () => _jsx(DropDown_FindingViewType.selectable, { selected: editable.item.type, onSelected: this.onFindingViewTypeSelected }) }
                ] }) });
    };
    renderEditor_ConnectedWizard = () => {
        const editable = this.state.editable;
        const wizard = ModuleFE_AdvisorWizard.cache.unique(editable.item.wizardId);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Connected Wizard', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: wizard?.label ?? 'N/A' }) },
                    { key: viewMode_Edit, renderer: () => _jsx(DropDown_AdvisorWizard.editable, { editable: editable, prop: 'wizardId', canUnselect: true }) }
                ] }) });
    };
    // ######################## Render - Editors - Parent ########################
    renderEditors_ParentFindingView = () => {
        const editable = this.state.editable;
        if (editable.item.type !== findingViewType_Parent)
            return;
        return _jsx(_Fragment, { children: this.renderEditor_Children() });
    };
    renderEditor_Children = () => {
        const editable = this.state.editable;
        const viableFindingViewIds = ModuleFE_FindingView.cache.filter(fv => fv._id !== editable.item._id && fv.type !== findingViewType_Parent).map(dbObjectToId);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Children Finding Views', children: _jsx(MultiSelect_FindingView, { editable: editable, prop: 'childrenIds', disabled: !this.state.editMode, itemFilter: id => viableFindingViewIds.includes(id) }) });
    };
    // ######################## Render - Editors - Sections ########################
    renderEditors_SectionsMeta = () => {
        const editable = this.state.editable;
        if (editable.item.type !== findingViewType_Sections)
            return;
        return _jsxs(_Fragment, { children: [this.renderEditor_SectionRenderMethod(), this.renderEditor_SectionSortMethod()] });
    };
    renderEditors_SectionsContent = () => {
        const editable = this.state.editable;
        if (editable.item.type !== findingViewType_Sections)
            return;
        return this.renderEditor_Sections();
    };
    renderEditor_SectionRenderMethod = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Section Render Method', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: editable.item.sectionRenderMethod }) },
                    { key: viewMode_Edit, renderer: () => _jsx(DropDown_SectionRenderMethod.editable, { editable: editable, prop: 'sectionRenderMethod' }) }
                ] }) });
    };
    renderEditor_SectionSortMethod = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Section Sort Method', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__finding-view__value', children: editable.item.sectionSortMethod }) },
                    { key: viewMode_Edit, renderer: () => _jsx(DropDown_SectionSortMethod.editable, { editable: editable, prop: 'sectionSortMethod' }) }
                ] }) });
    };
    renderEditor_Sections = () => {
        const editable = this.state.editable;
        const sections = editable.editProp('sections', []);
        return _jsx(TS_PropRenderer.Vertical, { label: this.renderEditor_Sections_Label, className: 'grow', children: _jsx(Editor_FindingViewSections, { editable: sections, editMode: this.state.editMode }) });
    };
    renderEditor_Sections_Label = () => {
        return _jsxs(_Fragment, { children: ["Sections", this.state.editMode && _jsx(ICONS.advisor_avn_add.component, { onClick: () => {
                        const editable = this.state.editable;
                        const sections = editable.editProp('sections', []);
                        sections.updateArrayAt(cloneObj(cleanFindingViewSection));
                        this.forceUpdate();
                    } })] });
    };
}
//# sourceMappingURL=Editor_FindingView.js.map